export const FETCH_FINANCIAL_COST_REQUEST = "FETCH_FINANCIAL_COST_REQUEST";
export const FETCH_FINANCIAL_COST_SUCCESS = "FETCH_FINANCIAL_COST_SUCCESS";
export const FETCH_FINANCIAL_COST_FAILURE = "FETCH_FINANCIAL_COST_FAILURE";
